// extracted by mini-css-extract-plugin
module.exports = {"credits-data":"ScreenFirst_credits-data__3V6v7"};